import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as federalAgencies from '../../federal-agencies'

export const RESOURCE = {
  payload: {
    description:
      'A government organization that funds, regulates, and oversees research initiatives.',
    dimension: federalAgencies.RESOURCE.payload,
    level: 0,
    name: 'Federal Agency',
    partialId: PartialId.Standard.create('agency'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
